import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../services/frontdoor/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  // <-- NOTE: Must be `styleUrls`, and an array:
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  username = '';
  password = '';
  showPassword = false;
  rememberMe = false;

  constructor(private loginService: LoginService, private router: Router) {}

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  onLogin() {
    if (!this.username || !this.password) {
      alert('Please enter username and password.');
      return;
    }

    this.loginService.login(this.username, this.password, this.rememberMe).subscribe(res => {
      if (res.success) {
        // Navigate to dashboard on success
        this.router.navigate(['/myaccount']);
      } else {
        alert(res.message);
      }
    }, err => {
      console.error(err);
      alert('Server error');
    });
  }

  onForgot() {
    this.router.navigate(['/forgot']);
  }
}
